/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AgencyGroupResponse,
    AgencyGroupResponseFromJSON,
    AgencyGroupResponseFromJSONTyped,
    AgencyGroupResponseToJSON,
    AgencyResponse,
    AgencyResponseFromJSON,
    AgencyResponseFromJSONTyped,
    AgencyResponseToJSON,
    BrandResponse,
    BrandResponseFromJSON,
    BrandResponseFromJSONTyped,
    BrandResponseToJSON,
    DistributionChannelResponse,
    DistributionChannelResponseFromJSON,
    DistributionChannelResponseFromJSONTyped,
    DistributionChannelResponseToJSON,
    MarketResponse,
    MarketResponseFromJSON,
    MarketResponseFromJSONTyped,
    MarketResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SystemContextResponse
 */
export interface SystemContextResponse {
    /**
     * 
     * @type {Array<BrandResponse>}
     * @memberof SystemContextResponse
     */
    brands?: Array<BrandResponse> | null;
    /**
     * 
     * @type {Array<DistributionChannelResponse>}
     * @memberof SystemContextResponse
     */
    channels?: Array<DistributionChannelResponse> | null;
    /**
     * 
     * @type {Array<MarketResponse>}
     * @memberof SystemContextResponse
     */
    markets?: Array<MarketResponse> | null;
    /**
     * 
     * @type {Array<AgencyGroupResponse>}
     * @memberof SystemContextResponse
     */
    agencyGroups?: Array<AgencyGroupResponse> | null;
    /**
     * 
     * @type {Array<AgencyResponse>}
     * @memberof SystemContextResponse
     */
    agencies?: Array<AgencyResponse> | null;
}

export function SystemContextResponseFromJSON(json: any): SystemContextResponse {
    return SystemContextResponseFromJSONTyped(json, false);
}

export function SystemContextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemContextResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brands': !exists(json, 'brands') ? undefined : (json['brands'] === null ? null : (json['brands'] as Array<any>).map(BrandResponseFromJSON)),
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(DistributionChannelResponseFromJSON)),
        'markets': !exists(json, 'markets') ? undefined : (json['markets'] === null ? null : (json['markets'] as Array<any>).map(MarketResponseFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(AgencyGroupResponseFromJSON)),
        'agencies': !exists(json, 'agencies') ? undefined : (json['agencies'] === null ? null : (json['agencies'] as Array<any>).map(AgencyResponseFromJSON)),
    };
}

export function SystemContextResponseToJSON(value?: SystemContextResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brands': value.brands === undefined ? undefined : (value.brands === null ? null : (value.brands as Array<any>).map(BrandResponseToJSON)),
        'channels': value.channels === undefined ? undefined : (value.channels === null ? null : (value.channels as Array<any>).map(DistributionChannelResponseToJSON)),
        'markets': value.markets === undefined ? undefined : (value.markets === null ? null : (value.markets as Array<any>).map(MarketResponseToJSON)),
        'agencyGroups': value.agencyGroups === undefined ? undefined : (value.agencyGroups === null ? null : (value.agencyGroups as Array<any>).map(AgencyGroupResponseToJSON)),
        'agencies': value.agencies === undefined ? undefined : (value.agencies === null ? null : (value.agencies as Array<any>).map(AgencyResponseToJSON)),
    };
}


